import { ReactNode } from 'react';

import styles from './PlayerTile.module.css';

// Состояние вместо видео, тех же пропорций: не подключен, удален, в приватной комнате.
// Вторая строка — детали: кто из судей с игроком или с каким игроком судья
export function TileState({
  text,
  note,
  children,
}: {
  text: string;
  note?: string;
  children?: ReactNode;
}) {
  return (
    <div className={styles.tile__state}>
      <span>{text}</span>
      {note && <span className={styles.tile__state_note}>{note}</span>}
      {children}
    </div>
  );
}
